var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrapper"},[_c('Bar',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.mergedOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }